import React, { useEffect, useMemo, useState } from 'react';
import Form, { useForm } from '../../molecules/Form';
import Field from '../Field';
import Button from '../../molecules/Button';
import Toast from '../../molecules/Toast';
import iconFile from '../../../assets/icon-csv-file.svg';
import iconFolder from '../../../assets/avatar-small.png';
import iconImg1 from '../../../assets/icon-arrow-magic.svg';
import iconImg2 from '../../../assets/icon-calendar.svg';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';
import Select from '../../molecules/Select';
import { GoArrowLeft } from 'react-icons/go';
import leadService from '../../../services/leadService';
import linkedinService from '../../../services/linkedinService';
import TagSelector from '../TagSelector/TagSelector';
import Step2 from './Step2';
import CenterModal from '../../molecules/Modal/CenterModal';
import LeadsData from './LeadsData';
import { MappingContacts, QuickTtips, TabsWrap } from './CreateCompaign.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import bkaclistService from '../../../services/blacklistService';
import { handleOnDrop, handleCampaignDrop } from '../../../helpers/common';
import campaignService from '../../../services/campaignService';
import selectArrow from '../../../assets/arrow-down-img.svg';
import Loaders from '../Loaders';

const Step1 = ({
  setData,
  NextStep,
  data,
  step,
  setStep,
  isInLeadsStep,
  setAddLeadsDataTab,
  setOpenLeadsModal: setParentOpenLeadsModal,
  csvInfo: addMoreLeadsCsvInfo,
  setCsvInfo: setAddMoreLeadsParentCsvInfo,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const campaignType = location.state?.campaign_type;
  const [form] = useForm();
  const [formData, setFormData] = useState(null);
  const [activeTab, setActiveTab] = useState(isInLeadsStep ? 'csv' : 'houdiny');
  const [loading, setLoading] = useState(false);
  const [selectedHoudinyLead, setSelectedHoudinyLead] = useState(null);
  const [openLeadsModal, setOpenLeadsModal] = useState(false);
  const [activeDataTab, setActiveDataTab] = useState('mapping');
  const [bsicCsvInfo, setBasicCsvInfo] = useState(null);
  const [isLeadsStep, setIsLeadsStep] = useState(isInLeadsStep);
  const [selectedTag, setSelectedTag] = useState(null);
  const csvInfo = addMoreLeadsCsvInfo !== undefined ? addMoreLeadsCsvInfo : bsicCsvInfo;
  const setCsvInfo = setAddMoreLeadsParentCsvInfo || setBasicCsvInfo;

  useEffect(() => {
    setIsLeadsStep(isInLeadsStep);
  }, [isInLeadsStep]);

  const [searchQuery, setSearchQuery] = useState({ getAll: true });
  const [listsQuery, setListsQuery] = useState({
    page: 1,
    itemsPerPage: 10,
    getAll: false,
  });
  const [allHoudinyLeads, setAllHoudinyLeads] = useState([]);
  const { user, fetch } = useContextHook(AuthContext, v => ({
    user: v.user,
    fetch: v.fetch,
  }));

  const { domains_loading, domains_data } = bkaclistService.GetAllBlacListDomain(searchQuery, fetch);

  const { lists_loading, lists_data } = linkedinService.GetAllUserLists(listsQuery, fetch);

  useEffect(() => {
    const incomingItems = lists_data?.data?.items || [];
    if (!Array.isArray(incomingItems) || incomingItems.length === 0) return;

    const mappedIncoming = incomingItems.map(i => ({
      label: i?.name,
      value: i?.id,
      leadCount: i?.leadCount,
      emailCount: i?.emailCount ?? i?.emailCounts,
      emailCounts: i?.emailCounts,
      blacklistCounts: i?.blacklistCounts,
    }));

    setAllHoudinyLeads(prev => {
      if (listsQuery.page === 1) {
        return mappedIncoming;
      }

      const merged = [...prev];
      mappedIncoming.forEach(item => {
        if (!merged.some(existing => existing.value === item.value)) {
          merged.push(item);
        }
      });
      return merged;
    });
  }, [lists_data, listsQuery.page]);

  useEffect(() => {
    setAllHoudinyLeads([]);
    setListsQuery(prev => ({ ...prev, page: 1 }));
  }, [fetch]);

  const totalHoudinyLeads = Number(lists_data?.data?.totalItems || 0);
  const canLoadMoreHoudinyLeads =
    !lists_loading && totalHoudinyLeads > 0 && allHoudinyLeads.length < totalHoudinyLeads;

  const handleHoudinyLeadsScrollEnd = () => {
    if (!canLoadMoreHoudinyLeads) return;
    setListsQuery(prev => ({ ...prev, page: prev.page + 1 }));
  };

  const houdinyLeads = useMemo(() => allHoudinyLeads, [allHoudinyLeads]);


  const handelSubmit = e => {
    if (activeTab === 'csv' && !isLeadsStep && !selectedTag) {
      Toast({
        type: 'error',
        message: 'Please select a tag before continuing',
      });
      return;
    }

    const step1Data = {
      ...e,
      rowLenght: formData?.rowData,
      columnNames: formData?.columnNames,
      rows: formData?.rows,
      campaign_name: e.campaign_name,
      csvfile: formData?.filteredCsvFile || e.csvfile,
      tagId: selectedTag,
    };
    if (activeTab === 'houdiny') {
      const selectedEmailCount = Number(e?.lead_list?.emailCount ?? e?.lead_list?.emailCounts ?? 0);
      const selectedBlacklistCount = Number(e?.lead_list?.blacklistCounts ?? 0);
      step1Data.list_id = e?.lead_list?.value;
      step1Data.leadCount = e?.lead_list?.leadCount;
      step1Data.emailCount = Math.max(selectedEmailCount - selectedBlacklistCount, 0);
      step1Data.blacklistCounts = e?.lead_list?.blacklistCounts;
    }

    setData(prev => ({
      ...prev,
      step1: step1Data,
    }));
    if (activeTab === 'houdiny') {
      setStep(2);
    } else {
      const totalRows = formData?.rows?.length || 0;

      if (totalRows === 0) {
        Toast({
          type: 'error',
          message: 'CSV has no valid emails. Please upload a valid file.',
        });
        return;
      }
      setCsvInfo({
        blockedEmails: formData?.blockedRows || [],
        duplicateEmails: formData?.duplicateEmails || [],
        totalEmails: formData?.totalEmails || [],
        totalContacts: formData?.totalContacts ?? formData?.rowData ?? 0,
      });

      if (isLeadsStep) {
        setAddLeadsDataTab('mapping');
      } else {
        setOpenLeadsModal(true);
      }
    }
  };

  useEffect(() => {
    if (data?.step1) {
      form.setFieldsValue({
        task_name: data?.step1?.task_name,
        csvfile: data?.step1?.csvfile,
        rows: data?.step1?.rows,
        campaign_name: data?.step1?.campaign_name,
        campaign_goal: data?.step1?.campaign_goal,
      });

      setFormData({
        file: data?.step1?.csvfile,
        columnNames: data?.step1?.columnNames,
        rowData: data?.step1?.rowLenght,
        rows: data?.step1?.rows,
      });
    }
  }, []);

  const tipDataCsv = [
    {
      img: iconImg1,
      title: 'Start With a Clear Goal',
      description:
        'Define what your campaign should achieve: replies, meetings, sign-ups, or awareness. Clear goals lead to stronger messaging.',
    },
    {
      img: iconImg2,
      title: 'Target the Right Audience',
      description:
        'Use precise, well-filtered lead lists. The more specific your audience, the more personal and effective your cold emails become.',
    },
    {
      img: iconImg1,
      title: 'Lead With the Problem',
      description:
        'Strong cold emails focus on the recipient’s pain point first. Introduce your product only after showing you understand their challenge.',
    },
    {
      img: iconImg2,
      title: 'Houdiny Leads Convert Faster',
      description:
        'Enriched Houdiny Leads typically deliver higher reply rates due to cleaner data and verified business emails..',
    },
  ];

  return (
    <>
      <CenterModal open={openLeadsModal} setOpen={setOpenLeadsModal} width={975} noHead padding="0">
        <MappingContacts>
          <div className="tab-btns">
            <span className={`btn ${activeDataTab === 'mapping' ? 'active' : ''}`}>Data Mapping</span>
            <span className={`btn ${activeDataTab === 'leadsData' ? 'active' : ''}`}>Import Contacts</span>
          </div>
          {activeDataTab === 'mapping' ? (
            <Step2
              setData={setData}
              data={data}
              NextStep={NextStep}
              step={step}
              setActiveDataTab={setActiveDataTab}
              setOpenLeadsModal={setOpenLeadsModal}
            />
          ) : (
            activeDataTab === 'leadsData' && (
              <LeadsData
                setStep={setStep}
                NextStep={NextStep}
                csvInfo={csvInfo}
                setOpenLeadsModal={setOpenLeadsModal}
                setActiveDataTab={setActiveDataTab}
                data={data}
                setData={setData}
                isInLeadsStep={isLeadsStep}
              />
            )
          )}
        </MappingContacts>
      </CenterModal>
      <Form className="form-area leads-step" form={form} onSubmit={handelSubmit}>
        <div className="column-wrap">
          <div className="left-col">
            <div className="head">
              <div>
                <span className="heading">Faster, Smarter, Houdiny</span>
                <p>Set up your campaign step by step</p>
              </div>
            </div>
            {!isLeadsStep && (
              <>
                <Form.Item
                  colorBg
                  inputSm
                  type="text"
                  label="Campaign name"
                  name="campaign_name"
                  placeholder="Enter campaign name..."
                  rules={[
                    {
                      required: true,
                      message: 'Name is required',
                    },
                  ]}>
                  <Field />
                </Form.Item>

                {activeTab === 'csv' && <TagSelector selectedTag={selectedTag} setSelectedTag={setSelectedTag} required />}

                <Form.Item
                  colorBg
                  inputSm
                  type="text"
                  label="Description"
                  name="campaign_goal"
                  placeholder="Enter campaign name...">
                  <Field />
                </Form.Item>
              </>
            )}
            <TabsWrap>
              {!isInLeadsStep && (
                <>
                  <span className="title">Lead Source</span>
                  {campaignType !== "ai" && (
                    <div className="tabs-btns">
                      <button
                        type="button"
                        className={`tabBtn ${activeTab === 'houdiny' ? 'active' : ''}`}
                        onClick={() => setActiveTab('houdiny')}>
                        <div className="btn-content">
                          <div className="icon-box">
                            <img src={iconFolder} width="32px" alt="folder" />
                          </div>
                          <div className="text-box">
                            <span className="subtitle">Select</span>
                            <span className="title">Houdiny Leads</span>
                          </div>
                          <span className="ico-tick" />
                        </div>
                      </button>
                      <button
                        type="button"
                        className={`tabBtn ${activeTab === 'csv' ? 'active' : ''}`}
                        onClick={() => setActiveTab('csv')}>
                        <div className="btn-content">
                          <div className="icon-box">
                            <img src={iconFile} width="25px" alt="file" />
                          </div>
                          <div className="text-box">
                            <span className="subtitle">Upload</span>
                            <span className="title">CSV File</span>
                          </div>
                          <span className="ico-tick" />
                        </div>
                      </button>

                    </div>
                  )}
                </>
              )}
              <div className="tab-content">
                {activeTab === 'houdiny' && (
                  <div className="content01">
                    <div className="selectwrap">
                      <Form.Item
                        type="select"
                        noMargin
                        selectSm
                        name="lead_list"
                        placeholder="Select Houdiny Leads"
                        options={houdinyLeads}
                        onMenuScrollToBottom={handleHoudinyLeadsScrollEnd}
                        isLoading={lists_loading}
                        rules={[
                          {
                            required: true,
                            message: 'Select houdiny leads list to continue',
                          },
                        ]}>
                        <Select />
                      </Form.Item>
                    </div>
                  </div>
                )}
                {/* CSV Upload tab */}
                {activeTab === 'csv' && (
                  <div className="content01">
                    <Form.Item
                      type="csv"
                      label="Upload your CSV file"
                      rounded
                      name="csvfile"
                      placeholder="csv file"
                      rules={[
                        {
                          required: true,
                          message: 'File is required to continue',
                        },
                      ]}
                      bg
                      disc="Drag & Drop or choose file to upload . Limit 200MB per file • CSV"
                      uploadTitle="Drag & Drop or choose file to upload"
                      fileSize={20}
                      icon
                      accept=".xlsx , .csv"
                      onUploadAccepted={(rawData, file) => {
                        handleCampaignDrop(rawData, file, user, setFormData, form, Toast, domains_data);
                      }}
                      onRemove={() => {
                        form.setFieldsValue({ csvfile: '' });
                      }}>
                      <Field />
                    </Form.Item>
                  </div>
                )}

                {/* Scrape CSV tab */}
                {/* {activeTab === 'scrape-csv' && (
                  <div className="content01">
                    <Form.Item
                      colorBg
                      inputSm
                      type="text"
                      label="Enter Scrape Source URL"
                      rounded
                      name="scrape_url"
                      placeholder="https://example.com"
                      rules={[
                        {
                          required: true,
                          message: 'Source URL is required',
                        },
                      ]}>
                      <Field />
                    </Form.Item>
                  </div>
                )} */}
              </div>
            </TabsWrap>
          </div>
          <div className="right-col">
            <QuickTtips>
              <div className="head">
                <strong className="title">Quick Tips</strong>
                <p>Here are some pointers to help you set up your campaign smoothly:</p>
              </div>
              <ul className="tip-list">
                {tipDataCsv?.map((item, index) => (
                  <li key={index}>
                    <div className="icon-box">
                      <img src={item.img} alt="img" />
                    </div>
                    <div className="text-box">
                      <strong className="title">{item.title}</strong>
                      <p>{item.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
              {/* <a href="#" className="btn-watch">
                Watch tutorial
              </a> */}
            </QuickTtips>
          </div>
        </div>
        <div className="btn-holder">
          <Button
            type="button"
            newStyle
            rounded
            variant="outline"
            width="155px"
            onClick={() => {
              if (setParentOpenLeadsModal) {
                setParentOpenLeadsModal(false);
              } else {
                navigate('/campaign-manager');
              }
            }}>
            Cancel
          </Button>
          <Button newStyle rounded variant="darkBlue" type="submit" width="155px" loader={loading} disabled={loading}>
            Next
          </Button>
        </div>
      </Form>
    </>
  );
};

export default Step1;
